import React, { useRef, useEffect, useState } from 'react';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useTheme from 'src/hooks/useTheme';
import { getMyTicketsGraph } from 'src/api/teacket';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const GraphMyTicketsTotalVsTenant = () => {
  const { isDarkMode } = useTheme();
  const [graphData, setGraphData] = useState(undefined);

  const refContainer = useRef();

  const themeMode = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
    },
  });

  const loadData = async () => {
    try {
      const resp = await getMyTicketsGraph('active-vs-tenant-all');
      setGraphData(resp);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!graphData) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={themeMode}>
      <div ref={refContainer}>
        {!graphData ? (
          <div className='text-center mt-10'>
            <Spin />
          </div>
        ) : (
          <>
            <div className='flex flex-row flex-wrap justify-center'>
              <Gauge
                colors={['#76b7b2', 'rgb(251 113 133)', '#f28e2c']}
                value={graphData.yours}
                valueMax={graphData.all}
                startAngle={-110}
                endAngle={110}
                width={150}
                height={150}
                innerRadius='75%'
                cornerRadius='50%'
                sx={{
                  [`& .${gaugeClasses.valueText}`]: {
                    fontSize: 20,
                    transform: 'translate(0px, 0px)',
                  },
                  [`& .${gaugeClasses.valueArc}`]: {
                    fill: '#76b7b2',
                  },
                }}
                text={({ value, valueMax }) => `${value} / ${valueMax}`}
              />
            </div>
            <div className='text-xs font-thin text-center whitespace-break-spaces'>Your all ticket(s) compared to the tickets for your Organization.</div>
          </>
        )}
      </div>
    </ThemeProvider>
  );
};

GraphMyTicketsTotalVsTenant.propTypes = {};

export default GraphMyTicketsTotalVsTenant;
